import React from 'react';
import { Button, ButtonProps, SxProps, Theme } from '@mui/material';
import styled from '@emotion/styled';
import MuiLoader from './Loader';

export interface CustomButtonProps extends ButtonProps {
    title?: string;
    onClick?: React.EventHandler<any>;
    width?: string | number;
    height?: string | number;
    fontSize?: number;
    backgroundColor?: string; // Add backgroundColor prop
    sx?: SxProps<Theme>;
    type?: 'button' | 'submit' | 'reset';
    loading?: boolean;
    disabled?: boolean;
    children?: React.ReactElement | React.ReactNode;
}

interface PrimaryButtonProps {
    width?: string | number;
    fontSize?: number;
    variant: 'outlined' | 'contained' | 'text';
    height?: string | number;
    sx?: any;
    color?: string;
}

const PrimaryButton = styled(Button)(({ width, fontSize, variant, height, sx, color }: PrimaryButtonProps) => {
    // Default value for variant
    const baseStyles = {
        boxShadow: 'none',
        padding: '6px 12px',
        width: width || '100%',
        height: height || 50,
        textTransform: 'capitalize',
        fontSize,
        '&:disabled': {
            backgroundColor: '#9CA3AF',
        },
    };

    const variantStyles: { [key: string]: object } = {
        outlined: {
            color: '#142456',
            borderColor: '#142456',
        },
        contained: {
            backgroundColor: '#000000',
            color: color === 'error' ? 'white' : '',
            '&:hover': {
                backgroundColor: color === 'error' ? '' : '#000000',
            },
        },
        text: {
            color: '#001AE3',
            width: 'fit-content',
        },
    };

    return {
        ...baseStyles,
        ...(variantStyles?.[variant] || {}),
        ...sx,
    };
});

export default function CustomButton({
    title,
    onClick,
    sx,
    backgroundColor,
    width,
    fontSize,
    loading,
    disabled,
    children,
    ...props
}: CustomButtonProps) {
    return (
        <PrimaryButton
            onClick={onClick}
            sx={sx}
            variant="contained"
            fontSize={fontSize || 18}
            disabled={loading || disabled}
            {...props}
            width={width}
        >
            {loading ? <MuiLoader loading={loading} size={30}></MuiLoader> : children || title}
        </PrimaryButton>
    );
}
